import React, { FC, useContext } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { UserContext } from '../../../../../user/UserContext';
import { Hyperlink } from '../../../../Hyperlink';
import { getFormattedDate } from '../../../../../utils/date-utils/dateUtils';
import styles from '../restricted_modal.module.scss';
import { RestrictedModalLayout } from '../RestrictedModalLayout';
import { MaterialIcon } from '../../../../material-icon/MaterialIcon';

type Props = {
  closeModal: () => void;
  source: string;
};

export const ExpiredRestrictedModal: FC<Props> = ({ closeModal, source }) => {
  const { currentUser } = useContext(UserContext);
  return (
    <RestrictedModalLayout closeModal={closeModal} source={source}>
      <span className={styles.logo} />
      <div className={styles.title}>
        <FormattedMessage
          id="expired/ExpiredRestrictedModal.tsx/1"
          values={{
            br: <br />,
            date: getFormattedDate(currentUser.expirationDate),
          }}
        />
      </div>
      <span className={styles.subtitle}>
        <FormattedMessage
          id="expired/ExpiredRestrictedModal.tsx/2"
          values={{ br: <br /> }}
        />
      </span>
      <Hyperlink
        className={classNames('button large brand', styles.startButton)}
        href="/tarifs"
        source={source}
      >
        <MaterialIcon name="arrow_forward" className={styles.arrow} />
        <FormattedMessage id="expired/ExpiredRestrictedModal.tsx/3" />
      </Hyperlink>
      <div className="restricted-modal__bottom" />
    </RestrictedModalLayout>
  );
};
